(() => {
  const root = window.Shopify?.routes?.root || '/';
  let pending = Promise.resolve();
  let checkoutReady = false;
  let checkoutPending = false;
  let cartChanging = false;
  const error = document.getElementById('prosema-delivery-error');

  function updateForm(form) {
    const field = form.querySelector('[data-prosema-delivery-property]');
    const data = form.querySelector('[data-prosema-delivery-variants]');
    if (!field || !data) return;
    const variants = JSON.parse(data.textContent);
    const variant = variants[form.querySelector('[name="id"]')?.value];
    field.value = variant?.tracked && variant.stock <= 0 ? variant.text : '';
  }

  async function synchronize() {
    if (cartChanging) return;
    const previouslyInert = document.body.inert;
    document.body.inert = true;
    let changed = false;
    try {
      // Read again after every write: Shopify can merge rows and replace their keys.
      for (let attempt = 0; attempt < 100; attempt++) {
        const response = await fetch(`${root}cart?section_id=prosema-delivery-cart`, {cache: 'no-store'});
        if (!response.ok) throw new Error('Delivery data unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const data = JSON.parse(html.querySelector('[data-prosema-delivery-cart]').textContent);
        const normalize = value => Array.isArray(value) ? Object.fromEntries(value) : {...(value || {})};
        const item = data.items.find(row => (normalize(row.properties)[data.label] || '') !== row.text);
        if (!item) {
          if (error) error.hidden = true;
          if (changed && !checkoutPending) document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
          return;
        }
        const properties = normalize(item.properties);
        properties[data.label] = item.text;
        const result = await fetch(`${root}cart/change.js`, {
          method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({id:item.key, quantity:item.quantity, properties})
        });
        if (!result.ok) throw new Error('Delivery update failed');
        changed = true;
      }
      throw new Error('Delivery update did not settle');
    } finally {
      document.body.inert = previouslyInert;
    }
  }

  function schedule() {
    pending = pending.catch(() => {}).then(synchronize);
    pending.catch(() => { if (error) { error.hidden = false; error.scrollIntoView({block:'center'}); } });
    return pending;
  }

  document.addEventListener('change', event => {
    const form = event.target.closest('form');
    if (form) updateForm(form);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    updateForm(form);
    if (event.submitter?.name !== 'checkout' || checkoutReady) {
      checkoutReady = false;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = event.submitter;
    if (cartChanging || checkoutPending) return;
    checkoutPending = true;
    schedule().then(() => {
      checkoutReady = true;
      form.requestSubmit(button);
    }).catch(() => {}).finally(() => { checkoutPending = false; });
  }, true);
  document.addEventListener('cart:item-added', schedule);
  document.addEventListener('line-item:change:start', () => { cartChanging = true; });
  document.addEventListener('line-item:change:end', () => { cartChanging = false; schedule(); });
  function initialize() {
    document.querySelectorAll('product-form form').forEach(updateForm);
    schedule();
  }
  initialize();
  window.addEventListener('pageshow', event => { if (event.persisted) initialize(); });
})();
